/**
 * [pug template]
 */
<template lang="pug">
    span.olst-text-component {{ text }}
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'text-component',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// TextComponent.vue?3b1c2eba